import axios from "./../index";

// ユーザーの特記事項API。
// バックエンド: app/controllers/api/v1/users/special_notes_controller.rb
// フェイスシート詳細と各相談サイドバーの双方から利用する。

const path = (userId: string) => `/api/v1/users/${userId}/special_note`;

export type SpecialNote = {
  specialNote: string;
  specialNoteRevisionId: string | null;
};

export default {
  fetchSpecialNote(userId: string, config: Record<string, unknown> = {}): Promise<SpecialNote> {
    return axios.get(path(userId), config).then((response) => response.data);
  },
  saveSpecialNote(userId: string, specialNote: string, baseRevisionId: string | null): Promise<SpecialNote> {
    return axios.put(path(userId), {
      special_note: specialNote,
      base_revision_id: baseRevisionId
    }).then((response) => response.data);
  }
};
